/**
 * Copyright (c) 2020
 *
 *
 * @summary
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-06-08 10:21:56
 * Last modified  : 2020-06-25 16:32:32
 */

import store from '@/store/store.js'
import apiCalls from '@/api/axios/customersManager/refreshToken.js'
import Vue from 'vue'
import toBoolean from 'to-boolean'
import ImpersonateService from '@/service/impersonate/ImpersonateService'

class AuthService {

    /**
     * Construct the logout URL and push the external redirection
     *
     * @param toURL String
     * @returns void
     */
    async redirectToExternalLogoutPage (toURL) {
        ImpersonateService.emailToSwitch = null // delete localstorage
        await store.dispatch('customersManager/unsetCustomer', this.getEmail())
        const url = new URL(`${process.env.VUE_APP_CUSTOMERS_MANAGER_FRONTEND_BASE_URI}/logout`)
        url.searchParams.append('continue', btoa(toURL))
        url.searchParams.append('product-family-handle', process.env.VUE_APP_PRODUCT_FAMILY_HANDLE)
        window.location = url.href
    }

    /**
     * Check if user is authenticated or nor
     *
     * @returns Boolean
     */
    isAuthenticated () {
        if (process.env.NODE_ENV !== 'production' && toBoolean(process.env.VUE_APP_AUTOLOGIN)) {
            return true;
        }
        return this.getConnected() && this.getEmail() !== null
    }

    /**
     * Fetch a user connected status on client side storage
     *
     * @returns Boolean
     */
    getConnected () {
        if (process.env.NODE_ENV !== 'production' && toBoolean(process.env.VUE_APP_AUTOLOGIN)) {
            return true
        }
        return Vue.$cookies.isKey('connected') ? toBoolean(Vue.$cookies.get('connected')) : false
    }

    /**
     * Fetch a user email on client side storage
     *
     * @returns String|null
     */
    getEmail () {
        if (process.env.NODE_ENV !== 'production' && toBoolean(process.env.VUE_APP_AUTOLOGIN)) {
            return 'john.doe@yooda.com'
        }
        return Vue.$cookies.isKey('email') ? Vue.$cookies.get('email') : null
    }

    /**
     * Renew accessToken and refreshToken when accessToken is expired
     * Refresh the customersManager part of store
     *
     * @returns void
     */
    async refreshToken () {
        await apiCalls.refreshToken()
        // this.retrieveSession()
    }

    /**
     * Reload the store concerning CustomersManager objects
     *
     * @returns void
     */
    async retrieveSession () {
        await store.dispatch(
            'customersManager/setCustomer',
            ImpersonateService.isCustomerSwitched ? ImpersonateService.emailToSwitch : this.getEmail()
        )
    }
}

export default new AuthService()
